<template>
  <v-app>
    <!-- <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png"
          transition="scale-transition"
          width="40"
        />

        <v-img
          alt="Vuetify Name"
          class="shrink mt-1 hidden-sm-and-down"
          contain
          min-width="100"
          src="https://cdn.vuetifyjs.com/images/logos/vuetify-name-dark.png"
          width="100"
        />
      </div>

      <v-spacer></v-spacer>

      <v-btn
        href="https://github.com/vuetifyjs/vuetify/releases/latest"
        target="_blank"
        text
      >
        <span class="mr-2">Latest Release</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </v-app-bar> -->
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  }),
};
</script>

<style lang="scss">
html,
body {
  margin: 0;
  height: 100%;
  overflow: hidden;
}
@import url("https://cdn.jsdelivr.net/gh/lazywasabi/thai-web-fonts@6/fonts/NotoSansThai/NotoSansThai.css");
.v-application {
  font-family: "Noto Sans Thai", sans-serif !important;
  background-color: var(--v-grayfooter-base) !important;
}
#app {
  font-family: Noto Sans Thai, sans-serif !important;
  background-size: cover;
  background-repeat: repeat-x;
}
.notoSans {
  font-family: "Noto Sans Thai", sans-serif !important;
  word-wrap: break-word;
}
.theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
  color: rgba(0, 0, 0, 0.88) !important;
}
.swal2-popup {
  border-radius: 30px !important;
  font-family: "Noto Sans Thai", sans-serif !important;
  padding-bottom: 50px !important;
  padding-right: 5px !important;
}
.v-dialog {
  border-radius: 8px !important;
}
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #e6e6e6;
}
::-webkit-scrollbar-thumb:hover {
  background: #cdcdcd;
}
.font-size-40 {
  font-size: 40px !important;
}
.font-size-32 {
  font-size: 32px !important;
}
.font-size-24 {
  font-size: 24px !important;
}
.font-size-22 {
  font-size: 22px !important;
}
.font-size-20 {
  font-size: 20px !important;
}
.font-size-18 {
  font-size: 18px !important;
}
.font-size-16 {
  font-size: 16px !important;
}
.font-size-14 {
  font-size: 14px !important;
}
.font-size-12 {
  font-size: 12px !important;
}
.main-color {
  color: #45a3ed !important;
}
.main-bg-color {
  background-color: #0f955d !important;
}
.content-container {
  padding: 24px 50px 50px 50px !important;
  background: #f5f5f5 !important;
  height: calc(95vh) !important;
  width: 100% !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}
.v-text-field--outlined {
  color: #45a3ed !important;
}
.card {
  padding: 24px;
  background-color: #ffffff;
  border-radius: 12px;
}
.card-s {
  padding: 24px;
  border-radius: 12px;
}
</style>